class CustomSelector extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.selectedValue = null;
    this.selectedText = null;
    this.placeholder = this.getAttribute("placeholder") || "Оберіть опцію";
    this.selectorIcon = this.getAttribute("data-select-icon");
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  render() {
    const options = Array.from(
      this.querySelectorAll(".subscribe-form__selector-option")
    );
    const currentOption = document.querySelector(
      ".subscribe-form__selector-option--selected"
    );
    const container = document.createElement("div");
    container.className = "subscribe-form__selector-container";

    const button = document.createElement("button");
    button.className = "subscribe-form__selector-button";
    button.type = "button";
    button.innerHTML = `
                    <span class="subscribe-form__selector-text">${currentOption.innerHTML}</span>
<img src="${this.selectorIcon}" alt="Select dropdown arrow" class="subscribe-form__selector-icon" loading="lazy" decoding="async" />`;
    const dropdown = document.createElement("div");
    dropdown.className = "subscribe-form__selector-dropdown";

    options.forEach((option) => {
      dropdown.appendChild(option.cloneNode(true));
    });

    container.appendChild(button);
    container.appendChild(dropdown);

    this.innerHTML = "";
    this.appendChild(container);

    this.button = button;
    this.dropdown = dropdown;
    this.textElement = button.querySelector(".subscribe-form__selector-text");
    this.icon = button.querySelector(".subscribe-form__selector-icon");
    this.options = dropdown.querySelectorAll(
      ".subscribe-form__selector-option"
    );
  }

  setupEventListeners() {
    this.button.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggle();
    });

    this.options.forEach((option) => {
      option.addEventListener("click", (e) => {
        e.stopPropagation();
        this.selectOption(option);
      });
    });

    document.addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        this.close();
      }
    });

    this.addEventListener("keydown", (e) => {
      this.handleKeydown(e);
    });

    this.setAttribute("tabindex", "0");
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.dropdown.classList.add("subscribe-form__selector-dropdown--open");
    if (this.icon) {
      this.icon.classList.add("subscribe-form__selector-icon--rotated");
    }
    this.focus();
  }

  close() {
    this.isOpen = false;
    this.dropdown.classList.remove("subscribe-form__selector-dropdown--open");
    if (this.icon) {
      this.icon.classList.remove("subscribe-form__selector-icon--rotated");
    }
  }

  selectOption(option) {
    this.options.forEach((opt) =>
      opt.classList.remove("subscribe-form__selector-option--selected")
    );

    option.classList.add("subscribe-form__selector-option--selected");
    this.selectedValue = option.dataset.value;
    this.selectedText = option.textContent;
    this.textElement.textContent = this.selectedText;
    this.textElement.classList.remove(
      "subscribe-form__selector-text--placeholder"
    );

    this.close();

    this.dispatchEvent(
      new CustomEvent("change", {
        detail: {
          value: this.selectedValue,
          text: this.selectedText,
        },
      })
    );
  }

  handleKeydown(e) {
    if (!this.isOpen) {
      if (e.key === "Enter" || e.key === " " || e.key === "ArrowDown") {
        e.preventDefault();
        this.open();
      }
      return;
    }

    const optionsArray = Array.from(this.options);
    const currentIndex = optionsArray.findIndex((opt) =>
      opt.classList.contains("selected")
    );

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        const nextIndex =
          currentIndex < optionsArray.length - 1 ? currentIndex + 1 : 0;
        this.selectOption(optionsArray[nextIndex]);
        break;
      case "ArrowUp":
        e.preventDefault();
        const prevIndex =
          currentIndex > 0 ? currentIndex - 1 : optionsArray.length - 1;
        this.selectOption(optionsArray[prevIndex]);
        break;
      case "Enter":
        e.preventDefault();
        this.close();
        break;
      case "Escape":
        e.preventDefault();
        this.close();
        break;
    }
  }

  getValue() {
    return this.selectedValue;
  }

  getText() {
    return this.selectedText;
  }

  setValue(value) {
    const option = Array.from(this.options).find(
      (opt) => opt.dataset.value === value
    );
    if (option) {
      this.selectOption(option);
    }
  }

  reset() {
    this.options.forEach((opt) => opt.classList.remove("selected"));
    this.selectedValue = null;
    this.selectedText = null;
    this.textElement.textContent = this.placeholder;
    this.close();
  }
}

customElements.define("custom-selector", CustomSelector);
